import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { key: 2 };
import PriorHeader from "@/components/PriorHeader.vue";
import PriorFooter from "@/components/PriorFooter.vue";
import { ref } from "vue";
import { miscService } from "@/services/miscService";
import { ApiError } from "@/services/api";
const bookmarkletHref = "javascript:void((async()=>{try{const m=window.location.href.match(/requests\\/([a-zA-Z0-9]+)/);if(!m){alert('Not on a CMM request page');return;}const r=await fetch('/api/requests/'+m[1],{credentials:'same-origin'});if(!r.ok){alert('API error: '+r.status);return;}const j=await r.json();await navigator.clipboard.writeText(JSON.stringify(j));const d=document.createElement('div');d.textContent='CMM JSON copied! ('+m[1]+')';d.style.cssText='position:fixed;top:20px;right:20px;background:%234CAF50;color:white;padding:16px 24px;border-radius:8px;z-index:99999;font-size:16px;box-shadow:0 4px 12px rgba(0,0,0,0.3)';document.body.appendChild(d);setTimeout(()=>d.remove(),3000)}catch(e){alert('Error: '+e.message)}})())";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OpsUtilities',
    setup(__props) {
        const errorMessage = ref("");
        const loading = ref(false);
        const s3LinksForRefresh = ref("");
        const refreshedS3Links = ref([]);
        const refreshS3Link = async () => {
            errorMessage.value = "";
            try {
                loading.value = true;
                const s3Links = s3LinksForRefresh.value
                    .replaceAll(/[\[\]'"]/g, "")
                    .trim()
                    .split(",")
                    .map((link) => link.trim());
                const response = await miscService.regenerateS3Links(s3Links);
                refreshedS3Links.value = response;
            }
            catch (error) {
                errorMessage.value = error instanceof ApiError ? error.message.toString() : `An unknown error occurred: ${error}`;
            }
            finally {
                loading.value = false;
            }
        };
        // CMM JSON Import — bookmarklet for copying CMM request JSON
        const cmmOrderKey = ref("");
        const cmmJsonText = ref("");
        const cmmLoading = ref(false);
        const cmmError = ref(null);
        const cmmResult = ref(null);
        const processCMMJson = async () => {
            cmmError.value = null;
            cmmResult.value = null;
            if (!cmmOrderKey.value.trim()) {
                cmmError.value = "Order key is required.";
                return;
            }
            if (!cmmJsonText.value.trim()) {
                cmmError.value = "CMM JSON is required.";
                return;
            }
            let parsed;
            try {
                parsed = JSON.parse(cmmJsonText.value);
            }
            catch {
                cmmError.value = "Invalid JSON. Please check the pasted content.";
                return;
            }
            if (!parsed.sections || !Array.isArray(parsed.sections)) {
                cmmError.value = 'JSON must contain a "sections" array.';
                return;
            }
            try {
                cmmLoading.value = true;
                const response = await miscService.processCMMJson({
                    order_key: cmmOrderKey.value.trim(),
                    cmm_json: parsed,
                });
                cmmResult.value = response;
            }
            catch (error) {
                cmmError.value = error instanceof ApiError ? error.message.toString() : `An unknown error occurred: ${error}`;
            }
            finally {
                cmmLoading.value = false;
            }
        };
        return (_ctx, _cache) => {
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_container = _resolveComponent("v-container");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(PriorHeader),
                _createVNode(_component_v_container, null, {
                    default: _withCtx(() => [
                        _cache[19] || (_cache[19] = _createElementVNode("h1", null, "Ops Utilities", -1)),
                        _createVNode(_component_v_container, null, {
                            default: _withCtx(() => [
                                (errorMessage.value)
                                    ? (_openBlock(), _createBlock(_component_v_alert, {
                                        key: 0,
                                        type: "error",
                                        variant: "tonal",
                                        closable: ""
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(errorMessage.value), 1)
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                _createElementVNode("h2", null, "Refresh S3 Links", -1)
                                            ])),
                                            _: 1,
                                            __: [3]
                                        }),
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                    modelValue: s3LinksForRefresh.value,
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((s3LinksForRefresh).value = $event)),
                                                    label: "S3 Links"
                                                }, null, 8, ["modelValue"]),
                                                _cache[4] || (_cache[4] = _createTextVNode(" Please paste a comma separated list of S3 links, with or without quotes or \"[]\" (can also be just one link). ", -1))
                                            ]),
                                            _: 1,
                                            __: [4]
                                        }),
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_btn, {
                                                    loading: loading.value,
                                                    onClick: refreshS3Link
                                                }, {
                                                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                        _createTextVNode("Refresh S3 Link", -1)
                                                    ])),
                                                    _: 1,
                                                    __: [5]
                                                }, 8, ["loading"])
                                            ]),
                                            _: 1
                                        }),
                                        (refreshedS3Links.value.length > 0)
                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                key: 0,
                                                cols: "12"
                                            }, {
                                                default: _withCtx(() => [
                                                    _cache[6] || (_cache[6] = _createElementVNode("b", null, "Refreshed S3 Links:", -1)),
                                                    _createVNode(_component_v_list, null, {
                                                        default: _withCtx(() => [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(refreshedS3Links.value, (link) => {
                                                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                                                    key: link,
                                                                    style: { 'line-break': 'anywhere' }
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(link), 1)
                                                                    ]),
                                                                    _: 2
                                                                }, 1024));
                                                            }), 128))
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1,
                                                __: [6]
                                            }))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_divider, { class: "my-6" }),
                                _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => [
                                                _cache[8] || (_cache[8] = _createElementVNode("h2", null, "Import CMM Request JSON", -1)),
                                                _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-body-2 mt-1 mb-2" }, " To copy CMM JSON: open the request in CMM, then run this bookmarklet (drag to bookmark bar): ", -1)),
                                                _createVNode(_component_v_chip, {
                                                    variant: "outlined",
                                                    class: "mb-3",
                                                    style: { "cursor": "grab", "user-select": "none" },
                                                    href: bookmarkletHref,
                                                    draggable: "true"
                                                }, {
                                                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                        _createTextVNode(" Copy CMM JSON ", -1)
                                                    ])),
                                                    _: 1,
                                                    __: [7]
                                                })
                                            ]),
                                            _: 1,
                                            __: [8, 9]
                                        }),
                                        _createVNode(_component_v_col, {
                                            cols: "12",
                                            md: "6"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_text_field, {
                                                    modelValue: cmmOrderKey.value,
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((cmmOrderKey).value = $event)),
                                                    label: "Order Key",
                                                    placeholder: "Enter the order key"
                                                }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_textarea, {
                                                    modelValue: cmmJsonText.value,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((cmmJsonText).value = $event)),
                                                    label: "CMM Request JSON",
                                                    rows: "10",
                                                    placeholder: "Paste the CMM request JSON here (must contain a \"sections\" array)"
                                                }, null, 8, ["modelValue"])
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_btn, {
                                                    loading: cmmLoading.value,
                                                    onClick: processCMMJson
                                                }, {
                                                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                        _createTextVNode("Process JSON", -1)
                                                    ])),
                                                    _: 1,
                                                    __: [10]
                                                }, 8, ["loading"])
                                            ]),
                                            _: 1
                                        }),
                                        (cmmError.value)
                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                key: 0,
                                                cols: "12"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_alert, {
                                                        type: "error",
                                                        variant: "tonal",
                                                        density: "compact"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(cmmError.value), 1)
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true),
                                        (cmmResult.value)
                                            ? (_openBlock(), _createBlock(_component_v_col, {
                                                key: 1,
                                                cols: "12"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_alert, {
                                                        type: "success",
                                                        variant: "tonal"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("div", null, [
                                                                _cache[11] || (_cache[11] = _createElementVNode("b", null, "Order:", -1)),
                                                                _createTextVNode(" " + _toDisplayString(cmmResult.value.order_key), 1)
                                                            ]),
                                                            _createElementVNode("div", null, [
                                                                _cache[12] || (_cache[12] = _createElementVNode("b", null, "Status:", -1)),
                                                                _createTextVNode(" " + _toDisplayString(cmmResult.value.status), 1)
                                                            ]),
                                                            _createElementVNode("div", null, [
                                                                _cache[13] || (_cache[13] = _createElementVNode("b", null, "Pipeline Step:", -1)),
                                                                _createTextVNode(" " + _toDisplayString(cmmResult.value.pipeline_step), 1)
                                                            ]),
                                                            (cmmResult.value.processing_summary)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                                                    _createElementVNode("div", null, [
                                                                        _cache[14] || (_cache[14] = _createElementVNode("b", null, "Form:", -1)),
                                                                        _createTextVNode(" " + _toDisplayString(cmmResult.value.processing_summary.form_name || "N/A"), 1)
                                                                    ]),
                                                                    _createElementVNode("div", null, [
                                                                        _cache[15] || (_cache[15] = _createElementVNode("b", null, "Fields Updated:", -1)),
                                                                        _createTextVNode(" " + _toDisplayString(cmmResult.value.processing_summary.updated_fields?.join(", ") || "None"), 1)
                                                                    ]),
                                                                    _createElementVNode("div", null, [
                                                                        _cache[16] || (_cache[16] = _createElementVNode("b", null, "Basic+ Questions:", -1)),
                                                                        _createTextVNode(" " + _toDisplayString(cmmResult.value.processing_summary.basic_plus_questions_count), 1)
                                                                    ]),
                                                                    _createElementVNode("div", null, [
                                                                        _cache[17] || (_cache[17] = _createElementVNode("b", null, "Payer Questions Extracted:", -1)),
                                                                        _createTextVNode(" " + _toDisplayString(cmmResult.value.processing_summary.payer_questions_extracted ? "Yes" : "No"), 1)
                                                                    ]),
                                                                    (cmmResult.value.processing_summary.cmm_state)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                                                            _cache[18] || (_cache[18] = _createElementVNode("b", null, "CMM State Detected:", -1)),
                                                                            _createTextVNode(" " + _toDisplayString(cmmResult.value.processing_summary.cmm_state.workflow_status || "None") + " ", 1),
                                                                            (cmmResult.value.processing_summary.cmm_state.is_approved)
                                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (Approved)"))
                                                                                : (cmmResult.value.processing_summary.cmm_state.is_denied)
                                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (Denied)"))
                                                                                    : (cmmResult.value.processing_summary.cmm_state.is_unknown)
                                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, " (Unknown outcome)"))
                                                                                        : _createCommentVNode("", true)
                                                                        ]))
                                                                        : _createCommentVNode("", true)
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1,
                    __: [19]
                }),
                _createVNode(PriorFooter)
            ], 64));
        };
    }
});
